import clsx from 'clsx'
import { useEffect } from 'react'
import PropTypes from 'prop-types'

const CellBooleanComponent = ({
  isReadOnly,
  payload,
  parentProps,
  inputProps,
  setInputProps,
  updatePayload,
  validateSchema,
  getFieldValue,
}) => {
  useEffect(() => {
    const fieldValue = getFieldValue(payload, parentProps)
    setInputProps({
      ...inputProps,
      value: fieldValue,
    })
  }, [payload])

  function onClick(e) {
    if (isReadOnly) return
    const value = e.target.value === 'yes'
    setInputProps({ ...inputProps, value })
    updatePayload(value)
    validateSchema(value)
  }

  function getRadioClass(checked) {
    return clsx(
      'w-[14px] h-[14px] rounded-full appearance-none',
      checked &&
        !isReadOnly &&
        'border-[3px] border-white bg-theme-50 shadow-[0_0_0_1px_var(--color-theme-50)]',
      !checked &&
        !isReadOnly &&
        'border-[3px] border-white bg-white shadow-[0_0_0_1px_var(--color-grey-50)]',
      isReadOnly &&
        checked &&
        'border-[3px] border-white bg-grey-90 shadow-[0_0_0_1px_var(--color-grey-90)]',
      isReadOnly &&
        !checked &&
        'border border-grey-90 bg-grey-90 shadow-[0_0_0_1px_var(--color-grey-90)]',
      !isReadOnly && 'cursor-pointer'
    )
  }

  if (!inputProps || !Object.keys(inputProps).length) return null

  return (
    <div className="flex flex-row gap-x-[30%]" data-testid="eform-boolean-container">
      <div className="flex justify-start items-center">
        <input
          type="radio"
          onClick={onClick}
          disabled={isReadOnly}
          data-testid="eform-boolean-input-yes"
          className={getRadioClass(inputProps.value === true)}
          value="yes"
          checked={inputProps.value === true}
          onChange={() => {}}
        />
        <label className="m-0 px-[6px] cursor-pointer">Yes</label>
      </div>
      <div className="flex justify-start items-center">
        <input
          type="radio"
          onClick={onClick}
          disabled={isReadOnly}
          data-testid="eform-boolean-input-no"
          className={getRadioClass(inputProps.value === false)}
          value="no"
          checked={inputProps.value === false}
          onChange={() => {}}
        />
        <label className="m-0 px-[6px] cursor-pointer">No</label>
      </div>
    </div>
  )
}

CellBooleanComponent.propTypes = {
  error: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  schema: PropTypes.object,
  payload: PropTypes.object,
  parentProps: PropTypes.array,
  inputProps: PropTypes.object,
  setInputProps: PropTypes.func,
  updatePayload: PropTypes.func,
  validateSchema: PropTypes.func,
  getFieldValue: PropTypes.func,
}

export default CellBooleanComponent
